import React from 'react';
import './MobileTopBar.css';
import rdvWideImg from '../../assets/rdv-logoW.png';

/**
 * Slim fixed top bar shown only in the mobile shell (AuthenticatedLayout
 * ≤768px). Hosts the hamburger that opens the Sidebar drawer.
 *
 * Brand left, menu right — mirroring the drawer, which slides in from the
 * right so it does not fight Android's left-edge back gesture. DOM order is
 * brand-then-menu so focus and screen-reader order follow the visual order.
 */
const MobileTopBar = ({ onMenuClick, title }) => (
  <header className='mobile-top-bar'>
    <div className='mobile-top-bar__brand'>
      <img src={rdvWideImg} alt='RDV' className='mobile-top-bar__logo' />
      {title ? <span className='mobile-top-bar__title'>{title}</span> : null}
    </div>
    <button
      className='mobile-top-bar__menu'
      onClick={onMenuClick}
      aria-label='Open menu'
    >
      <i className='fas fa-bars'></i>
    </button>
  </header>
);

export default MobileTopBar;
